import { CopywritingCampaign } from "../../../../List/pages/ListEditCopywriting/ListEditCopywriting";
import { ListPerson } from "../../../../List/schema/list";

/**
 * The valid campaigns of the lead's list, each with its id: the options of Review to send's "Assign
 * to campaign" picker. Moved out of `ReadyToSend.tsx` (over the file-length ratchet) unchanged.
 */
export function validCampaignsOfLead(lead: ListPerson | undefined): CopywritingCampaign[] {
	const allCampaigns = lead?.list?.campaignConfig as
		| { [key: string]: CopywritingCampaign }
		| undefined;

	if (!allCampaigns) {
		return [];
	}

	return Object.keys(allCampaigns)
		.filter((id) => allCampaigns[id]?.isValid)
		.map((id) => ({ ...allCampaigns[id], id }) as CopywritingCampaign);
}
